import { Component } from '@angular/core';

@Component({
  selector: 'app-hosting-aboutus',
  templateUrl: './hosting-aboutus.component.html',
  styleUrls: ['./hosting-aboutus.component.css']
})
export class HostingAboutusComponent {
  navClass = 'nav-light';
    // Set Topbar Option
  Menuoption = 'hosting';
  Settingicon = true
  footerVariant = 'footer-ten';
}
